module.exports = __webpack_public_path__ + "media/images/pic/labels/b1_1-e9da390bea5fe57e3d0fbf7bea2c7a86.png";